var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title mb-8"},[_c('div',{staticClass:"font-weight-regular title d-flex align-center",class:{ 'text-uppercase' : !_vm.noUppercase }},[_vm._t("default")],2),_c('div',{staticClass:"font-weight-light subtitle"},[_vm._t("subtitle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }